export class PaymentRetry {
  constructor($module) {
    if (!$module) return

    const $initial = $module.querySelector('#payment-retry-initial')
    const $liveRegion = $module.querySelector('#payment-retry-loading')
    const $button = $module.querySelector('.payment-retry__button')

    if (!$initial || !$liveRegion || !$button) return

    $button.addEventListener('click', (e) => {
      e.preventDefault()
      $initial.hidden = true
      $liveRegion.hidden = false
      setTimeout(() => {
        window.location.href = $button.href
      }, 3000)
    })
  }
}
